import axios from 'axios';
import { AppUserCurrentLocation } from '../models/AppUserCurrentLocation';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/users/currentlocations";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export const AppUserCurrentLocationService = {
    getLocationsPaginated: async (
        page: number,
        limit: number,
        search?: string,
        userId?: string | number,
        fromDate?: string,
        toDate?: string,
        warehouseId?: string | number
    ): Promise<{ locations: AppUserCurrentLocation[]; total: number }> => {
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (userId !== undefined && userId !== null && userId !== '') params.userId = userId;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        const response = await axios.get(`${API_URL}/getLocationsPaginated`, { params, headers: authHeader() });
        return response.data;
    },
    getAllLocations: async (): Promise<AppUserCurrentLocation[]> => {
        const response = await axios.get(`${API_URL}/getAllLocations`, { headers: authHeader() });
        return response.data;
    },
    getLocationById: async (id: number): Promise<AppUserCurrentLocation> => {
        const response = await axios.get(`${API_URL}/getLocationById/${id}`, { headers: authHeader() });
        return response.data;
    },
    getAllLocationsByUserId: async (id: number): Promise<AppUserCurrentLocation[]> => {
        const response = await axios.get(`${API_URL}/getAllLocationsByUserId/${id}`, { headers: authHeader() });
        return response.data;
    },
    getAllLocationsByUserIdToday: async (id: number): Promise<AppUserCurrentLocation[]> => {
        const response = await axios.get(`${API_URL}/getAllLocationsByUserIdToday/${id}`, { headers: authHeader() });
        return response.data;
    },
    createLocation: async (data: Omit<AppUserCurrentLocation, 'id' | 'created_time' | 'updated_time'>) => {
        const response = await axios.post(`${API_URL}/add`, data, { headers: authHeader() });
        return response.data;
    },
    updateLocation: async (id: number, data: Omit<AppUserCurrentLocation, 'id' | 'created_time' | 'updated_time'>) => {
        const response = await axios.put(`${API_URL}/update/${id}`, data, { headers: authHeader() });
        return response.data;
    },
    deleteLocation: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    },
};
